// CardReader.jsx
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Card from "../components/Card";
import { Filters } from "../ui/filter/Filters";
import { useDynamicFilters } from "./useDynamicFilters";
import { useLanguage } from "./LanguageContext";

const FILTER_DEFINITION = [
  { key: "theme", label: "Thème", source: "theme" },
  { key: "tag", label: "Tag", source: "tag" },
  // Ajouter d'autres filtres ici si nécessaire
];

const CardReader = () => {
  const [apps, setApps] = useState([]);
  const location = useLocation();
  const { language } = useLanguage();

  // Récupère les données depuis JSON
  useEffect(() => {
    const fetchData = async () => {
      try {
        const pathname = location.pathname || "/";
        const jsonFile =
          pathname === "/" ? "card/cards.json" : "card/indicateurs.json";
        const response = await fetch(jsonFile);
        const jsonData = await response.json();

        const isInterne = process.env.REACT_APP_DATA_TYPE === "interne";

        const filteredApps = jsonData.app
          .filter((item) => (isInterne ? true : item.public === "oui"))
          .map((item) => ({
            ...item,
            title: item[`title_${language}`] || item.title,
            description: item[`description_${language}`] || item.description,
          }));

        setApps(filteredApps);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des données JSON:",
          error,
        );
      }
    };
    fetchData();
  }, [location.pathname, language]);

  // Hook de filtres dynamiques
  const { filters, options, updateFilter, filteredItems } = useDynamicFilters(
    apps,
    FILTER_DEFINITION,
  );

  return (
    <div className="flex-1 w-full max-w-screen-xl mx-auto p-4">
      {/* Section des filtres */}
      <div className="mb-6 flex items-center justify-center gap-6 flex-wrap">
        {FILTER_DEFINITION.map((f) => (
          <Filters
            key={f.key}
            label={f.label}
            ids={f.key}
            values={filters[f.key] || ""}
            valuesList={options[f.key] || []}
            handleChange={(e) => updateFilter(f.key, e.target.value)}
          />
        ))}
      </div>

      {/* Grille responsive des cartes */}
      <div className="p-0 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-5">
        {filteredItems.map((item, index) => (
          <Card
            key={index}
            image={item.image}
            title={item.title}
            description={item.description}
            link={item.link}
            tags={item.tag}
            doc={item.doc}
            type={item.type}
            language={language}
          />
        ))}
      </div>
    </div>
  );
};

export default CardReader;
